import { EntityConfigService } from "../services/entity-config-service";
import * as Models from "../ts/rlAdmin.models";
import * as Consts from "../ts/rlAdmin.consts";

export class CustomViewsService {
    static $inject = ['entityConfigService'];
    parties: Models.IParty[];

    constructor(private entityConfigService: EntityConfigService) { }

    GetSpecialColumns(charTypeID?: number, parties?: Models.IParty[]): Models.ICustomUserColumn[] {
        var specialColumns: Models.ICustomUserColumn[] = [
            {
                charTypeID: charTypeID,
                sequenceNumber: 0,
                solrLabel: 'created',
                label: 'Created',
                formatter: 'dateLocal:"L"'
            },
            {
                charTypeID: charTypeID,
                sequenceNumber: 0,
                solrLabel: 'last_updated',
                label: 'Last Updated',
                formatter: 'dateLocal:"L"'
            },
            {
                charTypeID: charTypeID,
                sequenceNumber: 0,
                solrLabel: 'status_updated',
                label: 'Status Updated',
                formatter: 'dateLocal:"L"'
            }
        ]

		if (charTypeID == Consts.CharTypeIDs.transaction || charTypeID == Consts.CharTypeIDs.inventory || charTypeID == Consts.CharTypeIDs.job
			|| charTypeID == Consts.CharTypeIDs.project) {
			specialColumns.push({
				charTypeID: Consts.CharTypeIDs.user,
				sequenceNumber: 0,
				solrLabel: 'userlabel',
				label: 'Contact'
			});

			specialColumns.push({
				charTypeID: Consts.CharTypeIDs.user,
				sequenceNumber: 0,
				solrLabel: 'companylabel',
				label: 'Company'
			});

            if (charTypeID == Consts.CharTypeIDs.transaction) {

                specialColumns.push({
                    charTypeID: Consts.CharTypeIDs.transaction,
                    sequenceNumber: 0,
                    solrLabel: 'associated_catalog',
                    label: 'Associated Catalog'
                });

                if (parties) {
                    _.forEach(parties,
                        (e) => {
                            var partyName = e.partyName;
                            var solrLabel = partyName.toLowerCase().split(' ').join('_');
                            specialColumns.push({
                                charTypeID: Consts.CharTypeIDs.user,
                                sequenceNumber: 0,
                                solrLabel: solrLabel,
                                label: `Party: ${e.partyName}`
                            });
                        });
                }
            }
            else if (charTypeID == Consts.CharTypeIDs.inventory) {
                specialColumns.push({
                    charTypeID: Consts.CharTypeIDs.inventory,
                    sequenceNumber: 0,
                    solrLabel: 'associated_catalog_id',
                    label: 'Associated Catalog ID'
                });

                specialColumns.push({
                    charTypeID: Consts.CharTypeIDs.inventory,
                    sequenceNumber: 0,
                    solrLabel: 'associated_catalog',
                    label: 'Associated Catalog'
                });
            }

		} else if (charTypeID == Consts.CharTypeIDs.user) {
			specialColumns.push({
				charTypeID: Consts.CharTypeIDs.user,
				sequenceNumber: 0,
				solrLabel: 'company_name',
				label: 'Contact/Org'
			});

			specialColumns.push({
				charTypeID: Consts.CharTypeIDs.user,
				sequenceNumber: 0,
				solrLabel: 'associated_deal',
				label: 'Associated Deal'
			});

			specialColumns.push({
				charTypeID: Consts.CharTypeIDs.user,
				sequenceNumber: 0,
				solrLabel: 'associated_catalog',
				label: 'Associated Catalog'
			});
		} else if (charTypeID == Consts.CharTypeIDs.invoice) {
			specialColumns.push({
				charTypeID: Consts.CharTypeIDs.user,
				sequenceNumber: 0,
				solrLabel: 'transaction_id',
				label: 'Deal ID'
			});

			specialColumns.push({
				charTypeID: Consts.CharTypeIDs.user,
				sequenceNumber: 0,
				solrLabel: 'billing_contact',
				label: 'Billing Contact'
			});
		}
		else if (charTypeID == Consts.CharTypeIDs.property) {
			specialColumns.push({
				charTypeID: Consts.CharTypeIDs.user,
				sequenceNumber: 0,
				solrLabel: 'userlabel',
				label: 'Contact'
			});

			specialColumns.push({
				charTypeID: Consts.CharTypeIDs.user,
				sequenceNumber: 0,
				solrLabel: 'companylabel',
				label: 'Company'
			});

			specialColumns.push({
				charTypeID: Consts.CharTypeIDs.property,
				sequenceNumber: 0,
				solrLabel: 'top_parent',
				label: 'Top Parent'
			});

			specialColumns.push({
				charTypeID: Consts.CharTypeIDs.property,
				sequenceNumber: 0,
				solrLabel: 'direct_parent',
				label: 'Direct Parent'
			});

			specialColumns.push({
				charTypeID: Consts.CharTypeIDs.property,
				sequenceNumber: 0,
				solrLabel: 'associated_deal',
				label: 'Associated Deal'
			});

		}
		else if (charTypeID == Consts.CharTypeIDs.document) {
			specialColumns.push({
				charTypeID: Consts.CharTypeIDs.document,
				sequenceNumber: 0,
				solrLabel: 'last_updated_by',
				label: 'Last Updated By'
			});
		}
		else if (charTypeID == Consts.CharTypeIDs.right) {
			specialColumns.push({
				charTypeID: Consts.CharTypeIDs.right,
				sequenceNumber: 0,
				solrLabel: 'recordID',
				label: 'ID'
			});
		}
		else if (charTypeID == Consts.CharTypeIDs.amount) {
			specialColumns.push({
				charTypeID: Consts.CharTypeIDs.amount,
				sequenceNumber: 0,
				solrLabel: 'recordID',
				label: 'ID'
			});
		}
		if(charTypeID == Consts.CharTypeIDs.right || charTypeID == Consts.CharTypeIDs.transaction) {
            this.addDealColumns(specialColumns);
        }
        if (charTypeID == Consts.CharTypeIDs.right) {
            this.addCatalogColumns(specialColumns);
        }

        return specialColumns;
    }

    addCatalogColumns(specialColumns: Models.ICustomUserColumn[]) {
        specialColumns.push({
            charTypeID: Consts.CharTypeIDs.property,
            sequenceNumber: 0,
            solrLabel: "catalog_source",
            label: "Source Catalog"
        });
    }

    addDealColumns(specialColumns: Models.ICustomUserColumn[]) {
        specialColumns.push({
            charTypeID: Consts.CharTypeIDs.transaction,
            sequenceNumber: 0,
            solrLabel: "deal_id",
            label: "Deal ID"
        });
        specialColumns.push({
            charTypeID: Consts.CharTypeIDs.transaction,
            sequenceNumber: 0,
            solrLabel: "deal_title",
            label: "Deal Name"
        });
        specialColumns.push({
            charTypeID: Consts.CharTypeIDs.transaction,
            sequenceNumber: 0,
            solrLabel: "deal_primary_contact",
            label: "Deal Primary Contact"
        });
    }

    GetDefaultColumns(charTypeID: number): Models.ICustomUserColumns {
        var defaultColumns: Models.ICustomUserColumn[];
        switch (charTypeID) {
            case Consts.CharTypeIDs.amount: {
                defaultColumns = [
                    {
                        solrLabel: 'template',
                        label: 'Template',
                        charTypeID: -1,
                        sequenceNumber: 0
                    },
                    {
                        solrLabel: 'status',
                        label: 'Status',
                        charTypeID: -1,
                        sequenceNumber: 1
                    },
                    {
                        solrLabel: 'amount_double',
                        label: 'Amount',
                        charTypeID: -1,
                        sequenceNumber: 2
                    },
                    {
                        solrLabel: 'last_updated',
                        label: 'Last Updated',
                        charTypeID: -1,
                        sequenceNumber: 3
                    }
                ];
                break;
            }
            case Consts.CharTypeIDs.document: {
                defaultColumns = [
                    {
                        solrLabel: 'title',
                        label: 'Title',
                        charTypeID: -1,
                        sequenceNumber: 0
                    },
                    {
                        solrLabel: 'template',
                        label: 'Template',
                        charTypeID: -1,
                        sequenceNumber: 1
                    },
                    {
                        solrLabel: 'status',
                        label: 'Status',
                        charTypeID: -1,
                        sequenceNumber: 2
                    },
                    {
                        solrLabel: 'last_updated',
                        label: 'Updated',
                        charTypeID: -1,
                        sequenceNumber: 3
                    },
                    {
                        solrLabel: 'last_updated_by',
                        label: 'Updated By',
                        charTypeID: -1,
                        sequenceNumber: 4
                    }
                ];
                break;
            }
            default: {
                defaultColumns = [
                    {
                        solrLabel: 'title',
                        label: 'Title',
                        charTypeID: -1,
                        sequenceNumber: 0
                    },
                    {
                        solrLabel: 'template',
                        label: 'Template',
                        charTypeID: -1,
                        sequenceNumber: 1
                    },
                    {
                        solrLabel: 'status',
                        label: 'Status',
                        charTypeID: -1,
                        sequenceNumber: 2
                    },
                    {
                        solrLabel: 'last_updated',
                        label: 'Last Updated',
                        charTypeID: -1,
                        sequenceNumber: 3
                    }
                ];
                break;
            }
        }

        return {
            charTypeID: charTypeID,
            name: 'System Default',
            isDefault: true,
            isGlobal: false,
            columns: defaultColumns
        }
    }
}
